// extracted by mini-css-extract-plugin
module.exports = {"LoaderParent":"LoaderComponent_LoaderParent__ZoypB"};